// eslint-disable-next-line unicorn/prefer-global-this
export const canUseDOM = typeof window !== 'undefined' && typeof document !== 'undefined';
